// Switch between mock and real API implementation
const USE_REAL_API = true; // Set to true to use real API

let productService;

if (USE_REAL_API) {
  // Use real API implementation
  productService = require('./productService.real').default;
} else {
  // Use mock implementation for development
  productService = require('./productService.mock').default;
}

export default productService;